// extracted by mini-css-extract-plugin
module.exports = {"PowerOceanApp":"EcoFlow-App_PowerOceanApp__KusdC"};